import Cross from "@assets/svg/CrossIcon";
import color from "@constants/color";
import React from "react";
import { StyleSheet, TouchableOpacity, Text, View } from "react-native";

const L1FilterChip = ({ filterLevel, isSelected, onClickL1Filter }) => {
  return (
    <TouchableOpacity
      testID="L1FilterChip"
      key={filterLevel?.l1_filter_display_text}
      onPress={() => onClickL1Filter(filterLevel, isSelected)}
      style={{
        ...styles.chipBtn,
        backgroundColor: isSelected ? color.lightBlack : color.white,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Text
        style={{
          ...styles.tagText,
          color: isSelected ? color.white : color.black2,
        }}
        ellipsizeMode="tail"
        numberOfLines={1}
      >
        {filterLevel?.l1_filter_display_text}
      </Text>
      {isSelected && (
        <Text style={{ marginLeft: 4 }}>
          <Cross fill={color.white} width={14} height={14} fillOpacity={1} />
        </Text>
      )}
    </TouchableOpacity>
  );
};

const L2FilterChip = ({ filterLevel, isSelected, onClickL2Filter }) => {
  return (
    <TouchableOpacity
      testID="L2FilterChip"
      key={filterLevel?.l2_filter_display_text}
      onPress={() => onClickL2Filter(filterLevel, isSelected)}
      style={{
        ...styles.chipBtn,
        backgroundColor: isSelected ? color.lightBlack : "transparent",
      }}
    >
      <Text
        style={{
          ...styles.tagText,
          color: isSelected ? color.white : color.black2,
        }}
        ellipsizeMode="tail"
        numberOfLines={1}
      >
        {filterLevel?.l2_filter_display_text}
      </Text>
      {isSelected && (
        <Text style={{ marginLeft: 4 }}>
          <Cross fill={color.white} width={14} height={14} fillOpacity={1} />
        </Text>
      )}
    </TouchableOpacity>
  );
};

const PillWrapper = ({ height, width, marginRight = 0 }) => {
  return (
    <View
      style={{
        height,
        width,
        marginRight,
        backgroundColor: "#F0F0F0",
        borderRadius: 20,
      }}
    />
  );
};

const SearchPillSkelaton = () => {
  return (
    <View style={{ paddingHorizontal: 0 }}>
      <View style={styles.container}>
        <View style={styles.fields}>
          {[1, 2, 3, 4].map(() => {
            return <PillWrapper height={30} width={72} marginRight={6} />;
          })}
          <PillWrapper height={30} width={72} marginRight={0} />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    paddingVertical: 10,
  },
  fields: {
    flexDirection: "row",
    width: "100%",
  },
  chipBtn: {
    flexDirection: "row",
    paddingHorizontal: 10,
    borderWidth: 0.7,
    borderColor: color.borderBox,
    borderRadius: 20,
    marginRight: 8,
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    paddingVertical: 4,
  },
  tagText: {
    fontSize: 14,
    fontWeight: "400",
    color: color.black2,
    textAlignVertical: "center",
  },
});

export { L1FilterChip, L2FilterChip, SearchPillSkelaton };
